<template>
  <div>
    <layout v-if="switchAccountAfterLogin" class="layout">
    </layout>
      <ed-modal
        :class="['accounts-modal', !switchAccountAfterLogin ? 'not-on-top' : '']"
        :show='hasAccounts'
        title=''
        primaryButton='false'
        secondaryButton='false'
        close-on-click-away
        @close='closeAccountsModal'
      >
        <div slot="body">
          <h3 v-if="switchAccountAfterLogin" class="title text-center">You’re signed in.</h3>
          <h3 v-else class="title text-center">Switch Accounts</h3>

          <p class="text text-center">{{ currentEmail }}</p>
          <p class="text">You have multiple accounts with this email address. Select the account you would like to access.</p>

          <ed-input class="search"
            :placeholder='$t("Search Accounts")'
            v-model="search"
            search-box
          ></ed-input>
          <ul class="list">
            <li class="item list form-group"
              :class="{ disabled: accountToBeSet && accountToBeSet !== account.id }"
              :endpoint="accountToBeSet === account.id ? api.$.settings.my.switch : undefined"
              v-for="account in filteredAccounts"
              @click="setAccount(account); switchAccount(account)"
            >
              <p>{{ account.name }}</p>
              <span><i v-if="account.name === currentCompany" class="far fa-check pull-right"></i></span>
            </li>
          </ul>
        </div>
      </ed-modal>
    <!-- </layout> -->
  </div>
</template>

<script>

import metaNav from '@/core/components/edMetaNav'
import Layout from '@/components/Layouts/auth'
import { navigateToV3Home } from '@/core/legacy-auth/gotoV3'

const loginPaths = ['/login', '/login?mfa', '/login/mfasetup']

let hideSwitchAccount

export default {
  components: {
    Layout
  },

  data () {
    return {
      search: '',
      showSwitchAccount: typeof this.$route.query.switchAccount !== 'undefined' || this.$route.name === 'switchaccount',
      accountToBeSet: null,
      switchAccountAfterLoginEnabled: true
    }
  },

  created() {
    hideSwitchAccount = window.location.search.includes('noSwitchAccount') || document.referrer.includes('noSwitchAccount')
  },

  mounted() {
    if (hideSwitchAccount) {
      navigateToV3Home.call(this)
    }
  },

  computed: {
    accounts() {
      const userCompanies = this.$user.sessionSettings ? this.$user.sessionSettings.UserCompanies : {}
      return Object.keys(userCompanies).map(company => ({
        id: company,
        name: userCompanies[company],
        type: this.$user.$.domain
      }))
    },
    hasAccounts() {
      return this.accounts.length > 1 &&
        (
          (
            loginPaths.indexOf(this.$routerHistory.previous().path) !== -1 ||
            (
              !hideSwitchAccount &&
              (this.$routerHistory.previous().path || '').startsWith('/login')
            )
          ) &&
          this.switchAccountAfterLoginEnabled ||
          this.showSwitchAccount
        )
    },
    currentCompany() {
      return this.$user.$.data.CompanyName
    },
    currentEmail() {
      return this.$user.email
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    filteredAccounts() {
      let r = this.accounts.filter(account => account.name.toLowerCase().includes(this.search.toLowerCase()))
      r = r.sort((a, b) => {
        if (a.name < b.name) return -1
        else if (a.name > b.name) return 1
        return 0
      })
      return r
    },
    switchAccountAfterLogin() {
      return this.accounts.length > 1 &&
      (
        (
          !hideSwitchAccount &&
          (this.$routerHistory.previous().path || '').startsWith('/login')
        ) ||
        this.$route.name === 'switchaccount'
      ) &&
      this.switchAccountAfterLoginEnabled
    }
  },

  watch: {
    '$route.query.switchAccount' (value) {
      this.showSwitchAccount = typeof value !== 'undefined'
    }
  },

  methods: {
    switchAccount: metaNav.methods.switchAccount,

    setAccount(account) {
      const close = () => {
        this.switchAccountAfterLoginEnabled = false
        this.showSwitchAccount = false
        this.closeAccountsModal()

        this.$emit('dismiss')
      }

      this.accountToBeSet = account.id
      if (account.name === this.currentCompany) {
        close()
      }

      setTimeout(() => {
        close()
        this.accountToBeSet = null
      }, 1000)
    },

    closeAccountsModal() {
      this.$router.push({
        query: {
          ...this.$route.query,
          switchAccount: undefined
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/assets/sass/_variables.scss";

.layout >>> {
  .auth-layout-wrapper .logo-.partner- {
    display: none;
  }
  .auth-main-body {
    display: none;
  }
  .footer {
    display: none;
  }
}

.layout-auth + .accounts-modal >>> {
  .dawn-modal-top {
    display: none;
  }
}

.accounts-modal.dawn-modal-mask {
  background: none;
  
  &.not-on-top {
    background: rgba(0, 0, 0, 0.7);
  }
}
.accounts-modal >>> {
  .dawn-modal-container {
    position: relative;
    top: 10px;
    width: 400px;
    background: #fff;
  }
}

.title {
  font-size: 24px;
  margin: 0;
}

.text {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 15px;
}

.search {
  margin-bottom: 0;
}

.list {
  list-style: none;
  padding: 0;

  .fa-check {
    line-height: 28px;
    color: #4A90E2;
  }

  .item {
    font-size: 18px;
    padding: 10px 8px;
    margin-bottom: 0;
    cursor: pointer;
    border-top: 1px solid #ccc;
    display: flex;

    p {
      margin: 0px;
      width: 100%;
      padding-right: 4px !important;
    }

    span {
      text-align: right;
      align-self: center;
    }

    &:hover {
      @include theme {
      background-color: lighten(v(secondary-04), 7%);
      }
    }

    &.loading:before {
      margin-top: 8px;
      right: 12px;
    }

    &.disabled {
      opacity: 0.35;
      pointer-events: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Login/accounts.vue